import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIRoutes } from "APIRoutes";
import axios from "utils/axios";
import { utils } from "utils/utils";

export interface ServicesDto {
  loading: boolean;
  data: any[];
  allServices: any[];
}

export const setServicesData = createAsyncThunk(
  "service/setServicesData",
  async (data: any[]) => {
    return { data };
  }
);

export const getServices = createAsyncThunk("service/getServices", async () => {
  const response: any = await axios.get(APIRoutes.SERVICES);
  if (response.data?.statusCode) {
    utils.toastError(response.data?.message);
    return;
  }
  return { data: response?.data?.data ?? [] };
});

export const getAllServices = createAsyncThunk(
  "service/getAllServices",
  async () => {
    const response: any = await axios.get(APIRoutes.SERVICES_GET_ALL);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? [] };
  }
);

export const setAllServices = createAsyncThunk(
  "service/setAllServices",
  async (data: any[]) => {
    return { data };
  }
);

export const addNewService = createAsyncThunk(
  "service/addNewService",
  async (data: any) => {
    const response: any = await axios.post(APIRoutes.SERVICES, data);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? [] };
  }
);

export const updateService = createAsyncThunk(
  "service/updateService",
  async ({ id, data }: { id: any; data: any }) => {
    console.log("url", `${APIRoutes.SERVICES}/${id || ""}`);
    for (const [key, value] of data.entries()) {
      console.log(`${key}: ${typeof value}`);
    }
    const response: any = await axios.patch(
      `${APIRoutes.SERVICES}/${id || ""}`,
      data
    );
    //  console.log("response", response?.data);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

export const deleteService = createAsyncThunk(
  "service/deleteService",
  async (id: number) => {
    const response: any = await axios.delete(`${APIRoutes.SERVICES}/${id}`);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

const initialState: ServicesDto = {
  loading: false,
  data: [],
  allServices: [],
};

export const services = createSlice({
  name: "services",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getServices.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServices.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload?.data;
      })
      .addCase(getServices.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getAllServices.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllServices.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.allServices = payload?.data;
      })
      .addCase(getAllServices.rejected, (state) => {
        state.loading = false;
      })
      .addCase(setServicesData.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload?.data ?? [];
      })
      .addCase(setAllServices.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.allServices = payload?.data ?? [];
      });
  },
});

export default services.reducer;
